import { render } from "./SocialLinks.vue?vue&type=template&id=dfa48af0&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=dfa48af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa48af0"]])

export default __exports__